import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enCommon from './locales/en/common.json';
import enAdmin from './locales/en/admin.json';
import enBooking from './locales/en/booking.json';
import enValidation from './locales/en/validation.json';
import enLanding from './locales/en/landing.json';
import enLpSalonPain from './locales/en/lp-salon-pain.json';
import enLpSalonOutcome from './locales/en/lp-salon-outcome.json';
import enLpSalonBooking from './locales/en/lp-salon-booking.json';
import enSeoSalonBookingSoftware from './locales/en/seo-salon-booking-software.json';
import enSeoHairstylistBookingApp from './locales/en/seo-hairstylist-booking-app.json';
import enSeoBeautyProfessionalBooking from './locales/en/seo-beauty-professional-booking.json';
import enSeoSalonClientManagement from './locales/en/seo-salon-client-management.json';
import enSeoStopBookingClientsThroughDms from './locales/en/seo-stop-booking-clients-through-dms.json';
import enSeoSalonAppointmentReminders from './locales/en/seo-salon-appointment-reminders.json';
import enSeoSalonClientRetention from './locales/en/seo-salon-client-retention.json';
import enSeoOnlineBookingPageForHairstylists from './locales/en/seo-online-booking-page-for-hairstylists.json';
import enSeoSalonNoShowPrevention from './locales/en/seo-salon-no-show-prevention.json';
import enSeoSalonSoftwareForSoloStylists from './locales/en/seo-salon-software-for-solo-stylists.json';
import enToolsFormulaScaler from './locales/en/tools-formula-scaler.json';
import enToolsSalonPriceList from './locales/en/tools-salon-price-list.json';
import enToolsFloorPlan from './locales/en/tools-floor-plan.json';
import enTools from './locales/en/tools.json';
import esMXCommon from './locales/es-MX/common.json';
import esMXAdmin from './locales/es-MX/admin.json';
import esMXBooking from './locales/es-MX/booking.json';
import esMXValidation from './locales/es-MX/validation.json';
import esMXLanding from './locales/es-MX/landing.json';
import esMXToolsFormulaScaler from './locales/es-MX/tools-formula-scaler.json';
import esMXToolsSalonPriceList from './locales/es-MX/tools-salon-price-list.json';
import esMXToolsFloorPlan from './locales/es-MX/tools-floor-plan.json';
import esMXTools from './locales/es-MX/tools.json';

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'es-MX'],
    defaultNS: 'common',
    ns: [
      'common',
      'admin',
      'booking',
      'validation',
      'landing',
      'lp-salon-pain',
      'lp-salon-outcome',
      'lp-salon-booking',
      'seo-salon-booking-software',
      'seo-hairstylist-booking-app',
      'seo-beauty-professional-booking',
      'seo-salon-client-management',
      'seo-stop-booking-clients-through-dms',
      'seo-salon-appointment-reminders',
      'seo-salon-client-retention',
      'seo-online-booking-page-for-hairstylists',
      'seo-salon-no-show-prevention',
      'seo-salon-software-for-solo-stylists',
      'tools-formula-scaler',
      'tools-salon-price-list',
      'tools-floor-plan',
      'tools',
    ],
    resources: {
      en: {
        common: enCommon,
        admin: enAdmin,
        booking: enBooking,
        validation: enValidation,
        landing: enLanding,
        'lp-salon-pain': enLpSalonPain,
        'lp-salon-outcome': enLpSalonOutcome,
        'lp-salon-booking': enLpSalonBooking,
        'seo-salon-booking-software': enSeoSalonBookingSoftware,
        'seo-hairstylist-booking-app': enSeoHairstylistBookingApp,
        'seo-beauty-professional-booking': enSeoBeautyProfessionalBooking,
        'seo-salon-client-management': enSeoSalonClientManagement,
        'seo-stop-booking-clients-through-dms': enSeoStopBookingClientsThroughDms,
        'seo-salon-appointment-reminders': enSeoSalonAppointmentReminders,
        'seo-salon-client-retention': enSeoSalonClientRetention,
        'seo-online-booking-page-for-hairstylists': enSeoOnlineBookingPageForHairstylists,
        'seo-salon-no-show-prevention': enSeoSalonNoShowPrevention,
        'seo-salon-software-for-solo-stylists': enSeoSalonSoftwareForSoloStylists,
        'tools-formula-scaler': enToolsFormulaScaler,
        'tools-salon-price-list': enToolsSalonPriceList,
        'tools-floor-plan': enToolsFloorPlan,
        tools: enTools,
      },
      'es-MX': {
        common: esMXCommon,
        admin: esMXAdmin,
        booking: esMXBooking,
        validation: esMXValidation,
        landing: esMXLanding,
        'lp-salon-pain': enLpSalonPain,
        'lp-salon-outcome': enLpSalonOutcome,
        'lp-salon-booking': enLpSalonBooking,
        'seo-salon-booking-software': enSeoSalonBookingSoftware,
        'seo-hairstylist-booking-app': enSeoHairstylistBookingApp,
        'seo-beauty-professional-booking': enSeoBeautyProfessionalBooking,
        'seo-salon-client-management': enSeoSalonClientManagement,
        'seo-stop-booking-clients-through-dms': enSeoStopBookingClientsThroughDms,
        'seo-salon-appointment-reminders': enSeoSalonAppointmentReminders,
        'seo-salon-client-retention': enSeoSalonClientRetention,
        'seo-online-booking-page-for-hairstylists': enSeoOnlineBookingPageForHairstylists,
        'seo-salon-no-show-prevention': enSeoSalonNoShowPrevention,
        'seo-salon-software-for-solo-stylists': enSeoSalonSoftwareForSoloStylists,
        'tools-formula-scaler': esMXToolsFormulaScaler,
        'tools-salon-price-list': esMXToolsSalonPriceList,
        'tools-floor-plan': esMXToolsFloorPlan,
        tools: esMXTools,
      },
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'tilly-language',
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18next;
